<template>
    <div class="events-list">
        <table class="month month-list">
            <thead>
            <tr class="monthNav">
                <th colspan="7">
                    <a
                        v-if="mayLinkPrev"
                        v-html="'&laquo;'"
                        :href="prevLink"
                        :title="prevLabel"
                    />
                    <span
                        v-else
                        class="disabled"
                        v-html="'&laquo;'"
                    />

                    {{ monthLabel }}

                    <a
                        v-if="mayLinkNext"
                        v-html="'&raquo;'"
                        :href="nextLink"
                        :title="nextLabel"
                    />
                </th>
            </tr>
            </thead>
        </table>
        <p
            v-if="loading"
            v-text="'Loading...'"
        />
        <one-event
            v-else-if="events.length"
            v-for="event in events"
            :key="event.id"
            :event="event"
        />
        <p
            v-else
            v-text="'No events found.'"
        />
    </div>
</template>

<script>

import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import OneEvent from './OneEvent.vue';

dayjs.extend(customParseFormat);
export default {
    components: {
        OneEvent
    },

    props: {
        events: {
            type: Array,
            default: () => [],
        },
        eventType: {
            type: String,
            default: '',
        },
        month: {
            type: String,
            default: dayjs().format('YYYYMM'),
        },
        earliest: {
            type: String,
            default: dayjs().subtract(2, 'year').format('YYYYMM'),
        },
        loading: {
            type: Boolean,
        },
    },

    computed: {
        mayLinkPrev() {
            return this.month > this.earliest;
        },
        mayLinkNext() {
            return this.month < dayjs().format('YYYYMM');
        },
        prevLink() {
            return '/' + (this.eventType || 'events')
                + '/' + dayjs(this.month, 'YYYYMM').subtract(1, 'month').format('YYYYMM')
                + '#calendar';
        },
        prevLabel() {
            return dayjs(this.month, 'YYYYMM').subtract(1, 'month').format('MMMM YYYY');
        },
        monthLabel() {
            const label = dayjs(this.month, 'YYYYMM').format('MMMM YYYY');
            if (this.month === dayjs().format('YYYYMM')) {
                return label + ' and beyond';
            }
            return label;
        },
        nextLink() {
            return '/' + (this.eventType || 'events')
                + '/' + dayjs(this.month, 'YYYYMM').add(1, 'month').format('YYYYMM')
                + '#calendar';
        },
        nextLabel() {
            return dayjs(this.month, 'YYYYMM').add(1, 'month').format('MMMM YYYY');
        },
    },
}
</script>

<style lang="scss">
.events-month {
}
</style>
